import { ArrowDownRight, FileText, MapPin } from "lucide-react";
import { profile } from "../data/profile";
import { HeroIllustration } from "./HeroIllustration";

export function Hero() {
  return (
    <section className="hero shell" aria-labelledby="hero-title">
      <div className="hero-copy">
        <div className="availability-note">
          <span className="status-pulse" aria-hidden="true" />
          {profile.availability}
        </div>
        <p className="hero-overline">AI · SOFTWARE · ROBOTICS</p>
        <h1 id="hero-title">
          {profile.tagline}
          <span>Across pixels, products, and physical systems.</span>
        </h1>
        <p className="hero-lede">{profile.supportingLine}</p>
        <p className="hero-introduction">{profile.introduction}</p>
        <div className="hero-meta" aria-label="Profile details">
          <span><MapPin aria-hidden="true" /> {profile.location}</span>
          <span><FileText aria-hidden="true" /> {profile.academicStatus}</span>
        </div>
        <div className="hero-actions">
          <a className="button button-primary" href="#projects">
            Explore my work <ArrowDownRight aria-hidden="true" />
          </a>
          <a className="button button-ghost" href="#research">View research</a>
        </div>
      </div>
      <HeroIllustration />
    </section>
  );
}
